import {
  BusinessVerificationSectionDropdownOptionsResponse,
  BusinessVerificationSectionsResponse,
  UpdateBusinessVerificationSectionPayload,
} from "./types";
import { BaseResponse, GenericResponse } from "../types";

import request from "../request";
import { AUTH_URL } from "app/constants/variables";

const defaultOption = { baseURL: AUTH_URL };

export const getAllBusinessVerificationSections = () => {
  return request.get<GenericResponse<BusinessVerificationSectionsResponse>>(
    "/identities/business",
    {
      ...defaultOption,
    }
  );
};

export const updateBusinessVerificationSection = (
  section_key: string,
  payload: Partial<UpdateBusinessVerificationSectionPayload>
) => {
  return request.put<BaseResponse>(
    `/identities/business/${section_key}`,
    payload,
    { ...defaultOption }
  );
};

export const submitBusinessVerification = () => {
  return request.post<BaseResponse>(
    "/identities/business",
    {},
    { ...defaultOption }
  );
};

export const getBusinessVerificationSectionDropdownOptions = (
  section_key: string
) => {
  return request.get<
    GenericResponse<BusinessVerificationSectionDropdownOptionsResponse>
  >(`/identities/business/${section_key}/options`, defaultOption);
};

export const deleteBusinessOwner = (id: string) => {
  return request.delete<BaseResponse>(`/identities/business/owner/${id}`, {
    ...defaultOption,
  });
};
